export { default } from './WidePlayer'
